// @ts-nocheck
import * as React from "react";
import * as V from "../api";
import { Badge, Card, Empty, Loading, TOKENS, errorMessage, useToast } from "../ui";

// Phase 2 — 교육자원(학교·도서관·마을학교) + Youth 위치 간이 지도.
// 네이버 지도 SDK 로딩 복잡도를 피하기 위해, 좌표가 있는 자원·청소년을 **리스트**로 노출한다.
// 네이버 맵 통합(components/naver/*)은 Phase 2+ 로 보류 — 좌표 데이터는 API 로 확보.

const CAT_LABEL: Record<string, string> = {
  school: "학교", library: "도서관", village_school: "마을학교",
};

export function MapPanel({ isOperator }: { isOperator: boolean }) {
  const toast = useToast();
  const [cat, setCat] = React.useState("");
  const [resources, setResources] = React.useState<V.MapResource[] | null>(null);
  const [youths, setYouths] = React.useState<any[] | null>(null);

  const reload = React.useCallback(() => {
    V.mapLayer.resources(cat || undefined)
      .then((r) => setResources(r.items))
      .catch((e) => { setResources([]); toast.push(errorMessage(e), "danger"); });

    if (isOperator) {
      V.mapLayer.youths()
        .then((r) => setYouths(r.items))
        .catch(() => setYouths([]));
    }
  }, [cat, isOperator, toast]);

  React.useEffect(() => { reload(); }, [reload]);

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 8, marginBottom: 12 }}>
        <h2 style={{ fontSize: 16, fontWeight: 700, margin: 0 }}>교육자원 위치</h2>
        <div style={{ display: "flex", gap: 6 }}>
          {["", "school", "library", "village_school"].map((c) => (
            <button
              key={c || "all"}
              onClick={() => setCat(c)}
              style={{
                padding: "4px 10px", borderRadius: 999, fontSize: 12,
                border: `1px solid ${cat === c ? TOKENS.orange500 : TOKENS.border}`,
                background: cat === c ? TOKENS.orange50 : "transparent",
                color: cat === c ? TOKENS.orange600 : TOKENS.ink2,
                cursor: "pointer",
              }}
            >{c === "" ? "전체" : CAT_LABEL[c]}</button>
          ))}
        </div>
      </div>

      {resources === null ? <Loading /> :
       resources.length === 0 ? <Empty title="등록된 교육자원이 없습니다." /> :
        <div style={{ display: "grid", gap: 8, marginBottom: 24 }}>
          {resources.map((r) => (
            <Card key={r.id}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 12 }}>
                <div style={{ minWidth: 0 }}>
                  <div style={{ fontSize: 14, fontWeight: 700 }}>
                    {r.name}&nbsp;<Badge tone="info">{CAT_LABEL[r.category] || r.category}</Badge>
                  </div>
                  <div style={{ fontSize: 12, color: TOKENS.ink3, marginTop: 2 }}>
                    {r.address || "주소 미기재"} · 좌표 {r.lat.toFixed(4)}, {r.lng.toFixed(4)}
                  </div>
                </div>
              </div>
            </Card>
          ))}
        </div>
      }

      {isOperator && (
        <>
          <h2 style={{ fontSize: 16, fontWeight: 700, margin: "16px 0 12px" }}>청소년 위치 (운영자 전용)</h2>
          {youths === null ? <Loading /> :
           youths.length === 0 ? <Empty title="좌표가 등록된 청소년이 없습니다." hint="청소년 상세에서 좌표를 입력하면 여기에 표시됩니다." /> :
            <div style={{ display: "grid", gap: 8 }}>
              {youths.map((y) => (
                <Card key={y.id}>
                  <div style={{ display: "flex", justifyContent: "space-between", gap: 12 }}>
                    <div>
                      <div style={{ fontSize: 14, fontWeight: 700 }}>
                        {y.name}&nbsp;<Badge tone="info">{V.LABELS.youthTrack[y.track]}</Badge>
                      </div>
                      <div style={{ fontSize: 12, color: TOKENS.ink3, marginTop: 2 }}>
                        좌표 {y.lat.toFixed(4)}, {y.lng.toFixed(4)}
                      </div>
                    </div>
                  </div>
                </Card>
              ))}
            </div>
          }
        </>
      )}

      <div style={{
        marginTop: 24, padding: 14, borderRadius: 12, background: TOKENS.bgSub,
        border: `1px solid ${TOKENS.borderSoft}`, fontSize: 12, color: TOKENS.ink2, lineHeight: 1.6,
      }}>
        <strong>Phase 2+ 지도 통합 예정</strong> — 좌표 데이터는 이 패널에서 확보되며,
        네이버 지도 SDK 레이어는 통합돌봄 <code>/map</code> 과 동일한 <code>components/naver/*</code>
        훅으로 결합할 예정입니다.
      </div>
    </div>
  );
}
